import mutations from './mutations'
import actions from './actions'

const state = {
  all_logs: [],
  logs: [],
  log: [],
  deleted_logs: [],
  auth_logs: [],
  feature_logs: [],
  password_resets_logs: [],
  change_logs:[],
  single_change_log:{}
}

export default {
  state, mutations, actions
}
